import { defineMessages } from 'react-intl';

export const customerStateMessages = defineMessages({
  NEW: {
    id: 'customer_state.new',
    defaultMessage: 'New',
    description: 'The label of new applications',
  },
  VIEWED: {
    id: 'customer_state.viewed',
    defaultMessage: 'Viewed',
    description: 'The label of viewed application',
  },
  ARCHIVED: {
    id: 'customer_state.archived',
    defaultMessage: 'Archived',
    description: 'The label of archived application',
  },
});

export const teamFilterMessages = defineMessages({
  allTeams: {
    id: 'customer_filter.teams.all_teams',
    defaultMessage: 'All teams',
    description: 'Display item for all teams option in the teams filter dropdown',
  },
});
